module.exports = __webpack_public_path__ + "img/Certificate_3.553ac4ac.jpg";